<template>
  <div />
</template>

<script>
export default {
  name: 'EmptyLayout',
};
</script>
